import { render } from "./IndexManagement.vue?vue&type=template&id=befdcba0"
import script from "./IndexManagement.vue?vue&type=script&lang=js"
export * from "./IndexManagement.vue?vue&type=script&lang=js"

import "./IndexManagement.vue?vue&type=style&index=0&id=befdcba0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__